module.exports = __webpack_public_path__ + "static/media/B6.e8293163.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/B6.png
// module id = 885
// module chunks = 0